import React from 'react'
import gql from 'graphql-tag'
import {shouldShowDeliveredPhotos} from 'lib/productHelpers'
import DeliveredPhotos from 'components/shared/DeliveredPhotos'
import DefaultProductStatus from '../../DefaultProductStatus'
import ProvideInput from './ProvideInput'

const RetouchedPhotoProduct = ({match, product, viewer}) => {
  const getCostForInputAssets = (selectedPhotos) => {
    const {remainingCredits, extraAssetUnitPrice} = product
    return (selectedPhotos.length - remainingCredits) * extraAssetUnitPrice
  }

  const photoOrder = viewer.photoOrderPreference.edges.map(edge => edge.node.name)

  if (product.canProvideUserInput) {
    return (
      <ProvideInput
        match={match}
        estateId={match.params.estateId}
        product={product}
        minQuantity={product.quantity}
        getTotalCost={getCostForInputAssets}
        photoOrder={photoOrder}
      />
    )
  }

  if (shouldShowDeliveredPhotos(product)) {
    const photoOrder = viewer.photoOrderPreference.edges.map(edge => edge.node.name)
    return (
      <DeliveredPhotos
        estateId={match.params.estateId}
        product={product}
        photoOrder={photoOrder}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

RetouchedPhotoProduct.fragment = gql`
  fragment RetouchedPhotoProduct on Product {
    ...on DigitalRetouchedFurnishingPhotoProduct {
      inputAssets {
        ...InputAssets
      }
    }
    ...on DigitalRetouchedRenovationPhotoProduct {
      inputAssets {
        ...InputAssets
      }
    }
    ...on DigitalRetouchedPeoplePhotoProduct {
      inputAssets {
        ...InputAssets
      }
    }
  }
  fragment InputAssets on AssetsConnection {
    edges {
      node {
        id
        ...on PhotoAsset {
          image(size: "monitor") {
            url
            thumbUrl
            width
            height
            labels
            filenameIndex
          }
        }
      }
    }
  }
`

export default RetouchedPhotoProduct
